
import { defineComponent, PropType } from "vue";

import Tile from "@/models/Tile";
import PlayerPicture from "@/components/Elements/PlayerPicture.vue";

export default defineComponent({
  components: { PlayerPicture },
  inject: ["game"],
  data: () => ({
    candidatePlayersToStealFrom: [] as number[],
  }),
  props: {
    tile: { type: Object as PropType<Tile>, required: true },
  },
  computed: {
    canMoveThief(): boolean {
      return this.game.availableActions.includes("MoveThief");
    },
    movingThief(): boolean {
      return this.game.isMovingThief;
    },
    recievingThief(): boolean {
      return this.game.tileRecievingThief === this.tile.id;
    },
    className(): string[] {
      const classes = [
        this.tile.resource
          ? `tile-${this.tile.resource.toLowerCase()}`
          : "tile-desert",
      ];
      if (this.tile.hasThief && !this.movingThief && !this.recievingThief) {
        classes.push("has-thief");
      }
      if (this.movingThief && !this.tile.hasThief) {
        classes.push("moving-thief");
      }
      if (this.recievingThief && this.candidatePlayersToStealFrom.length > 0) {
        classes.push("recieving-thief");
      }
      return classes;
    },
    probability(): number {
      return this.tile.number
        ? this.tile.number <= 7
          ? this.tile.number - 1
          : 13 - this.tile.number
        : 0;
    },
  },
  methods: {
    handleClick() {
      if (this.movingThief && !this.tile.hasThief) {
        this.prepareToRecieveThief();
      }
    },
    handleThiefClick() {
      if (this.canMoveThief) {
        this.game.startMovingThief();
      }
    },
    prepareToRecieveThief() {
      const stealablePlayers = this.game.getStealablePlayers(this.tile);
      if (stealablePlayers.length === 0) {
        this.recieveThief();
      } else {
        this.candidatePlayersToStealFrom = stealablePlayers;
        this.game.setTileRecievingThief(this.tile.id);
      }
    },
    recieveThief(stealFrom?: number) {
      this.game.moveThief(this.tile.id, stealFrom);
    },
  },
  watch: {
    recievingThief(newValue: boolean) {
      if (!newValue) {
        this.candidatePlayersToStealFrom = [];
      }
    },
  },
});
